import React, { memo } from 'react';
import classnames from 'classnames';

import { isMediaQuery } from '~/core/scripts/mediaquery-helper';
import Icon from '~/core/scripts/components/Icon';
import { isTouch, numberFormat } from '~/core/scripts/utils';

import './tooltip.styl';

const TOOLTIP_WIDTH = 300;

const Tooltip = memo(({ data, pos, isVisible, onClose, dataMode }) => {
  const isInverted = pos.x + 35 + TOOLTIP_WIDTH >= window.innerWidth / 2;
  const style = isMediaQuery(769) ? { left: `${pos.x + (isInverted ? -25 : 25)}px`, top: `${pos.y - 75}px` } : {};
  const tooltipClass = classnames('tooltip-wrapper', { 'is-active': isVisible, invert: isInverted });
  const isClosable = isTouch || !isMediaQuery(769);

  if (!data || !data.data) {
    return null;
  }

 const { state, table_name, ags_name_kurz, agsAbs, agsDelta, agsRel, changeSign } = data.data;

  const handleClose = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    onClose();
  };
  
  return (
    <div className={tooltipClass} style={{ ...style, borderColor: data.color }}>
      <div className="tooltip">
        {isClosable && (
          <button className="btn close" onClick={handleClose}>
            <Icon type="close" />
          </button>
        )}
        <div className="tooltip-header">
          {state !== table_name && <div className="tooltip-kicker">{state}</div>}
          <div className="tooltip-title">{table_name}</div>
          {ags_name_kurz !== table_name && <div className="tooltip-subtitle">{ags_name_kurz}</div>}
        </div>
        <div className="tooltip-body">
          <div className="tooltip-item" style={{ opacity: dataMode === 'sleeping' ? 1 : 1 }}>
            <div className="tooltip-value">{numberFormat(agsAbs)}</div>
            <div className="tooltip-value-title">Neuinfektionen</div>
            <div className="tooltip-value-sub">{numberFormat(agsRel, 1)} pro 100.000 EW</div>
          </div>
          <div className="tooltip-item secondary" style={{ opacity: dataMode === 'sleeping' ? 0.5 : 0.5 }}>
            {!isNaN(agsDelta) && isFinite(agsDelta) && (agsDelta !== -9999999999) && 
              <div className="tooltip-value">{changeSign}{numberFormat(agsDelta, 0, "%")}</div>
            }
            {(agsDelta === -9999999999) && 
              <div className="tooltip-value">↘&#xFE0E;</div>
            }
            {(isNaN(agsDelta) || !isFinite(agsDelta)) && 
              <div className="tooltip-value">↗&#xFE0E;</div>
            }
            <div className="tooltip-value-title">Veränderung</div>
            <div className="tooltip-value-sub">seit Ferienbeginn</div>
            {/*
              <div className="tooltip-value">{numberFormat(beliebtheit)}</div>
              <div className="tooltip-value-title">Übernachtungen</div>
              <div className="tooltip-value-sub">Øxx Tage Aufenthalt</div>
            */}
          </div>
        </div>
      </div>
    </div>
  );
});

Tooltip.displayName = 'Tooltip';

export default Tooltip;
